import React from "react";
import Header from "../header/Header";
function Press() {
  return (
    <>
      <Header></Header>

      <div
        id="carouselExampleSlidesOnly"
        class="carousel slide"
        data-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              class="d-block w-100 vip"
              src="./style/img/banner/respirolabsbanner.jpg"
              alt="First slide"
            />
          </div>
        </div>
      </div>
      <section class="blog-area area-padding">
        <div class="container">
          <div class="area-heading row"></div>

          <div class="row">
            <div class="col-md-6 col-lg-3 col-md-3">
              <div class="single-blog">
                <div class="thumb">
                  <img
                    class="img-fluid"
                    src="./style/img/banner/Pulmonologistbannernew.jpg"
                    alt=""
                  />
                </div>
                <div class="short_details">
                  <div class="meta-top d-flex text-dark">
                    Early testing and diagnosis of diseases are crucial for
                    better recovery. Respiro foundation is introducing lab
                    facilities exclusive for lung conditions. Affordable and
                    widespread testing facilities will help to increase testing
                    rates and improve patient's number seeking better
                    healthcare. Respiro offer wide range of advanced test
                    facilities under the supervision of medical professionals
                    and also provides walk-in facilities for simple tests like
                    spirometry and other Lungs Function Tests. Early defection
                    of lung cancer, COPD, lugs fibrosis, sleep apnea etc.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-md-3">
              <div class="single-blog">
                <div class="thumb">
                  <img
                    class="img-fluid"
                    src="./style/img/banner/RTbanner01.jpg"
                    alt=""
                  />
                </div>
                <div class="short_details">
                  <div class="meta-top d-flex text-dark">
                    A respiratory therapist(RT) is a specialized healthcare
                    practitioner trained in critical care and cardio-pulmonary
                    medicine in order to work therapeutically with people who
                    have acute critical conditions, cardiac and pulmonary
                    disease. Respiratory therapists initiate and manage life
                    support for people in intensive care units and emergency
                    departments, stabilizing, treating and managing pre-hospital
                    and hospital-to-hospital patient transport by air or ground
                    ambulance.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-md-3">
              <div class="single-blog">
                <div class="thumb">
                  <img
                    class="img-fluid"
                    src="./style/img/banner/respirolabsbanner.jpg"
                    alt=""
                  />
                </div>
                <div class="short_details">
                  <div class="meta-top d-flex text-dark">
                    Until faced with a serious difficulty, breathing is the most
                    taken-for-granted biological activity in our body. But the
                    lung is a major internal organ exposed to the risks of the
                    external environment and is highly susceptible to health
                    hazards due to pollution, microbes and toxins Respiro Labs
                    is not just an advanced diagnosis facility but also a walk
                    in facility where you can take a quick appointment to assess
                    lung function without the recommendation of a doctor
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 col-md-3">
              <div class="single-blog">
                <div class="thumb">
                  <img
                    class="img-fluid"
                    src="./style/img/banner/rhf.png"
                    alt=""
                  />
                </div>
                <div class="short_details">
                  <div class="meta-top d-flex text-dark">
                    A rapid heal force (RHF) is a team of health care providers
                    that responds to patients with early signs of deterioration
                    on non-intensive care units to prevent respiratory or
                    cardiac arrest. The health care providers are trained in
                    early resuscitation interventions and advanced life support.
                    The team responds to calls placed by clinicians or families
                    at the bedside who have detected deterioration. Rapid
                    response teams appear to decrease the rates of respiratory
                    and cardiac arrest outside the intensive care unit.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Press;
